var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c(_vm.layout,{tag:"component",attrs:{"user":_vm.user}},[_c('router-view',{attrs:{"user":_vm.user,"layout":_vm.layout},on:{"update:layout":function($event){_vm.layout=$event}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }